import React, { useEffect, useRef, useState } from 'react';
import Grid from '@mui/material/Unstable_Grid2';
import {CircularProgress} from '@mui/material';
import {useNavigate, useSearchParams} from 'react-router-dom';
import {useMutation} from "@tanstack/react-query";
import {API_URLS, axiosRequest} from "@lib/axios";

const Verify = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const [verifying, setVerifying] = useState(true);
  // Using a ref, too, to prevent duplicate async requests on subsequent state renders
  const verifyRef = useRef(false);

  const confirmAccountMutation = useMutation({
    mutationFn: async (data) => axiosRequest({
      method: 'POST',
      url: `${API_URLS.AUTH}/confirm`,
      data,
    }),
    onSuccess: async () => {
      console.log('[Verify] Account confirmed. Redirecting to login...');
      navigate('/login', {
        state: { message: 'Your account has been verified. Please sign in.' }
      });
    },
    onError: async (err) => {
      console.error('[Verify] Error confirming account:', err);
      let message = err.message;
      if (message === 'Invalid verification code provided, please try again.') {
        message = 'The verification link is expired.';
      }
      if (message === 'User cannot be confirmed. Current status is CONFIRMED') {
        message = 'Your account has already been verified. Please sign in.';
      }
      navigate('/login', {
        state: { message }
      });
    },
    onSettled: () => {
      verifyRef.current = false;
      setVerifying(false);
    }
  });

  useEffect(() => {
    const userpool_user_id = searchParams.get('user');
    const code = searchParams.get('code');

    if (!userpool_user_id || !code) {
      console.log('[Verify] no username or code, sending error');
      setVerifying(false);
      console.log('[Verify] redirect to login');

      navigate('/login', {
        state: { error: 'Invalid verification link.' }
      });
    } else if (!verifyRef.current) {
      verifyRef.current = true;
      console.log('[Verify] Running mutation');
      confirmAccountMutation.mutate({ userpool_user_id, code });
    }
  }, [searchParams, navigate, confirmAccountMutation]);

  return (
    <Grid container spacing={3}>
      {verifying && (
        <>
          <Grid xs={12} display="flex" justifyContent="center">
            Please wait while your account is verified. Afterwards, you will be redirected to the login page.
          </Grid>
          <Grid xs={12} display="flex" justifyContent="center">
            <CircularProgress/>
          </Grid>
        </>
      )}
    </Grid>
  );
};

export default Verify;
